import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DAPPROVER_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetch = (header: any) => ({
    type: 'FETCH_DAHEADER_SUCCESS',
    payload: header,
});



export const fetchHeaderData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = DAPPROVER_API.daprofile_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetch(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

